/* Mottakerregister for Quantum-decket: merkevarefarge (deckets eneste aksent), sceneplate (03), Lab-navn og «Why»-punkter.
   Logoene ligger i det felles registeret (../headliner/brands.js). Ukjent navn → tekst-wordmark, generisk plate og deckets egen aksent. */
import { logoOf, Wordmark } from "../headliner/brands";

export { Wordmark };

/* «Why X» — hvorfor akkurat dette rommet er strategisk interessant for X. Punkt 2 bærer mottakerens egen tese; resten er felles. */
const WHY = (name, shift) => [
  ["The audience is the operations", `The people in the room run Norway's shipping, energy, seafood and public services — the scheduling and routing problems ${name}'s systems are built for.`],
  ["From research to production", shift],
  ["Result, not theatre", "The main stage shows a real case with a real result, compared honestly with the company's current approach — not a roadmap slide."],
  [`A category ${name} can own`, "One quantum company owns the story of quantum at work in Norwegian business. Exclusively — on the main stage and in the room."],
];
const GENERIC_SHIFT = "Quantum optimisation is moving from research into production. Most Norwegian boards have not heard that first-hand.";

/* D-Wave: annealing + hybridløsere i produksjon (NTT DOCOMO nettdrift, Pattison Food Group bemanning, Ford Otosan produksjonsplaner — D-Waves egne kundehistorier). */
const DWAVE = {
  color: "#58bbba",
  plate: "/images/build-stage-d-wave.webp",
  lab: "The Quantum Lab — with D-Wave",
  why: (n) => WHY(n, "Annealing quantum computing and hybrid solvers are in production today — network operations, workforce scheduling, manufacturing. Most Norwegian boards have not heard that first-hand."),
};

export const BRANDS = {
  "d-wave": DWAVE,
  dwave: DWAVE,
  "d-wave quantum": DWAVE,
};

export const brandOf = (name) => {
  const b = BRANDS[(name || "").trim().toLowerCase()];
  return { name, color: null, plate: "/images/build-stage.webp", lab: `The Quantum Lab — with ${name}`, why: (n) => WHY(n, GENERIC_SHIFT), logo: logoOf(name), ...b };
};

/* Merkevarefargen som deckets aksent (erstatter gul) når mottakeren er kjent */
export const brandRootStyle = (name) => {
  const b = brandOf(name);
  return b.color ? { "--hd-gul": b.color, "--bd-brand": b.color } : undefined;
};
